export default {
    setAutoLogout(state) {
      state.did_auto_logout = true;
    },
    logged(state,new_value) {
      state.logged = new_value;
    },
    setAuthprofile(state, payload) {
        if( payload == null ) {
            state.authenticated_profile = null;    
        } else {
            state.authenticated_profile = {
                profile_id: payload.profileid,
                name: payload.name,
                surname: payload.surname,
                role: payload.role,
                token: payload.token,
                tokenDuration: payload.token_duration
            };
            state.did_auto_logout = false;
        }

    },

    openEditImgs(state){
        state.openEditImgs++
    },
  
    setAclMap(state, map){
        state.acl_map = map;
    },
    main_loader(state, new_value){
        state.main_loader = new_value;
    },
    try_login_one_time(state, new_value){
        state.try_login_one_time = new_value;
    }
  };